import { FC } from 'react';
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button
} from '@material-ui/core';

interface DetailsDialogProps {
  open: boolean;
  onClose: () => void;
  details?: object | string;
}

export const DetailsDialog: FC<DetailsDialogProps> = ({
  open,
  onClose,
  details
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="sm"
    fullWidth
    PaperProps={{
      style: {
        borderRadius: 16
      }
    }}>
    <DialogTitle>
      <Box
        style={{
          justifyContent: 'space-between',
          display: 'flex',
          alignItems: 'center'
        }}>
        Details
      </Box>
    </DialogTitle>
    <DialogContent>
      <pre
        style={{
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word',
          margin: 0,
          padding: 16,
          backgroundColor: '#f5f5f5',
          borderRadius: 12
        }}>
        {typeof details === 'string'
          ? details
          : JSON.stringify(details, null, 2)}
      </pre>
    </DialogContent>
    <DialogActions style={{ justifyContent: 'flex-end' }}>
      <Button
        onClick={onClose}
        color="primary"
        style={{
          marginRight: 12,
          borderRadius: 120,
          textTransform: 'none'
        }}>
        Close
      </Button>
    </DialogActions>
  </Dialog>
);
